import { ColumnInstance, MetaBase } from 'react-table'
import { ActionColumnProps } from '../Spectable.types'
import { PinningProps } from '../settings/TableSettings'

export interface PinnedColumnsProps<TData extends Object> {
    checkboxColumnWidth: number
    showPinning: boolean
    pinningProps: PinningProps
    actionColumnProps?: ActionColumnProps<TData>
}

const pinnedColumns = <TData extends Object>({
    checkboxColumnWidth,
    showPinning,
    pinningProps,
    actionColumnProps,
}: PinnedColumnsProps<TData>) => (
    columns: ColumnInstance<TData>[],
    { instance }: MetaBase<TData>
) => {
    if (!showPinning) return columns

    const columnsToReturn = [...columns]

    const lastIndexOfVisibleCol = columnsToReturn.length - 1

    // remove all sticky's and apply the new ones
    columnsToReturn.forEach((col, idx) => {
        // Apply first column pinning when there is no group by.
        // Group by sticky is handled in groupedColumn
        if (
            !instance.state.groupBy.length &&
            idx === 0 &&
            pinningProps.firstColumnPinned
        ) {
            col.sticky = 'left'
            col.stickyLeftMargin = checkboxColumnWidth
            return
        }

        if (pinningProps.lastColumnPinned && lastIndexOfVisibleCol === idx) {
            col.sticky = 'right'
            col.stickyRightMargin = actionColumnProps?.width ?? 0
            return
        }

        col.sticky = undefined
        col.stickyRightMargin = undefined
    })

    return columnsToReturn
}

export default pinnedColumns
